// @ts-nocheck
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import { InputsInTable } from "../../InputInTable/InputsInTable";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast, SuccessToast, WarningToast } from "../../ToastComponent/RectHotToast";
import { ConnectionMemoInputFields, formFieldupdation } from "../AddConnectionMemoReceive/ConnectionMemoReceiveConfig";
import "./AddConnectionMemoReceive.scss";
import AddConnectionMemoReceiveInputs from "./AddConnectionMemoReceiveInputs";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import { useModalContext } from "../../Reactportal/ModalContext";
import { useEventListener } from "usehooks-ts";
import {
  CREATE_CONNECTION_MEMO_RECEIVE,
  delete_Connection_Receive,
  EDIT_CONNECTION_MEMO_RECEIVE,
  GET_CONNECTION_MEMO_RECEIVE_BY_ID,
  getFormSectionsAndFields,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { convertToISO, IsoToDateWithoutTime } from "../../../../CommonFunction/IsoDateTime";
import { useDispatch } from "react-redux";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import {
  ClearFields,
  handleFormReset,
  updateSingleField,
  updateValueForm,
} from "../../FormInputSectionComponent/formUtils";
import { RiErrorWarningFill } from "react-icons/ri";

const GET_CONNECTION_MEMO_RECEIVE = gql`
  query GetConnectionMemoUpdate_WithConnectionMemoIdAndConnectionNumber($id: ID!) {
    getConnectionMemoUpdate_WithConnectionMemoIdAndConnectionNumber(ConnectionMemoUpdationId: $id) {
      _id
      Unique_Id
      Date
      Memo_No
      LR_No
      Vehicle_No
      Connection_No
      Total_Connected_Box
      LoadReceiptsIds
      ConnectionMemoUpdationData {
        _id
        LoadReceiptId
        LR_No
        Total_Number_Of_Boxes
        Balance_for_Connection
        Connected
        Offloaded
      }
    }
  }
`;

const AddConnectionMemoReceive = ({
  show,
  TypeOfPortal,
  ParentPortalCloseFunction,
  submitType,
  openByCard,
  FormDetailsByCard,
}) => {
  const formkey = "Connection_Memo_Receive";
  const { pushModal, popModal, getTopModal } = useModalContext();
  const [openModal, setOpenModal] = useState(show ? show : false);
  const [memoId, setMemoId] = useState("");
  const [loadIds, setLoadIds] = useState([]);
  const dispatch = useDispatch();
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Connection_Memo_Receive?.Selected_Row;
  const [FormData, setFormdata] = useState({});
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [InputFields, setInputFields] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [currentBranch, setCurrentBranch] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [GetLRData] = useLazyQuery(GET_CONNECTION_MEMO_RECEIVE, {
    fetchPolicy: "network-only",
  });

  const previousValue = useRef<any>();
  const [CreateConnectionMemoReceive, { loading: CreateLoading }] = useMutation(CREATE_CONNECTION_MEMO_RECEIVE);
  const [EditConnectionMemoReceive, { loading: EditLoading }] = useMutation(EDIT_CONNECTION_MEMO_RECEIVE);
  const [DeleteConnectionMemoReceive, { loading: DeleteLoading }] = useMutation(delete_Connection_Receive);
  const [GetConnectionMemoReceiveById, { loading: getLoading }] = useLazyQuery(GET_CONNECTION_MEMO_RECEIVE_BY_ID, {
    fetchPolicy: "no-cache",
  });
  const [getFormSectionAndFields, { loading: getFormSectionAndFieldsLoading }] = useLazyQuery(
    getFormSectionsAndFields,
    {
      variables: {
        key: formkey,
      },
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        setInputFields(data?.formSectionAndFields);
      },
    }
  );
  const [connectionUpdationData, setConnectionUpdationData] = useState<any>([]);
  const [tableFields, setTableFields] = useState({});
  const headers = ["LR No", "No Of Boxes", "Short", "Received"];
  const arr = ["LR Number", "No Of Boxes", "Short"];
  const formRef = useRef({});
  let loader = CreateLoading || EditLoading || getLoading;

  const Closeformfunction1 = () => {
    ClearSpecificForm(dispatch, formkey);
    setTableFields({});
    handleFormReset(formRef);
    ParentPortalCloseFunction();
    popModal(formkey);
    setOpenModal(false);
  };

  useEffect(() => {
    if (TypeOfPortal !== "Delete") {
      getFormSectionAndFields();
    }
  }, []);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Connection_Memo_Receive?.SelRows_ids || []);
  }, [fielddataRedux]);

  useEffect(() => {
    if (TypeOfPortal == "Edit" && InputFields?.length) {
      const inputNames = ["Received_At", "Memo_Number"];

      inputNames.forEach((name) => {
        const input = document.getElementsByName(name);
        if (input.length > 0) {
          const lastInput = input[input.length - 1] as HTMLInputElement;
          lastInput.disabled = true;
        }
      });
    }
  }, [InputFields]);

  useEffect(() => {
    if (FormData?.Received_At && TypeOfPortal == "Add") {
      setTableFields({});
    }
  }, [FormData?.Received_At]);

  useEffect(() => {
    const value = FormDataFromRedux?.MasterData[formkey]?.Branch_Code;
    if (TypeOfPortal === "Add" && value && currentBranch && currentBranch?._id !== value?._id && !openByCard) {
      ClearSpecificForm(dispatch, formkey);
      ClearFields(formRef);
      setTableFields({});
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: formkey,
          data: {
            Branch_Code: value,
          },
        },
      });
    }
    setCurrentBranch(value);
  }, [FormDataFromRedux?.MasterData[formkey]?.Branch_Code?._id]);

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  useEffect(() => {
    if (InputFields.length) {
      if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") {
        GetConnectionMemoReceiveById({
          variables: {
            id: fielddata?._id,
          },
        }).then((res) => {
          console.log(res);
          let MemoUpdationData = { ...res?.data?.getConnectionMemoReceiveByIdWithLR[0] };
          setMemoId(MemoUpdationData?.ConnectionMemoUpdateId_Data?._id);
          setLoadIds(MemoUpdationData?.LoadReceiptsIds);
          let obj = {};
          // setMemoId(res.data.getConnectionMemoByIdWithLR[0]._id);
          let temp = MemoUpdationData.ConnectionMemoReceiveData;
          temp.forEach((item) => {
            const key = Math.random() * 10;
            obj[key] = formFieldupdation.map((fieldConfig) => {
              console.log(fieldConfig);
              if (
                fieldConfig.name === "LR Number" ||
                fieldConfig.name === "No Of Boxes" ||
                fieldConfig.name === "Short" ||
                fieldConfig.name === "Received"
              ) {
                return {
                  ...fieldConfig,
                  value:
                    item[
                    fieldConfig.name === "LR Number"
                      ? "LR_No"
                      : fieldConfig.name === "No Of Boxes"
                        ? "Total_Number_Of_Boxes"
                        : fieldConfig.name === "Short"
                          ? "Short"
                          : fieldConfig.name === "Received"
                            ? "Received"
                            : ""
                    ],
                };
              } else {
                return {
                  ...fieldConfig,
                };
              }
            });
          });
          console.log(obj);
          setTableFields(obj);
          let arr1: any = [];
          for (let i = 0; i < temp.length; i++) {
            let obj1: any = {};
            obj1.LoadReceiptId = temp[i].LoadReceiptId;
            obj1.Total_Number_Of_Boxes = temp[i].Total_Number_Of_Boxes;
            obj1.Short = temp[i].Short;
            obj1.Received = temp[i].Received;
            arr1.push(obj1);
          }
          setConnectionUpdationData(arr1);
          // const idArray = temp.map((item: any) => item.LoadReceiptId);
          // setLRIds(idArray);

          delete MemoUpdationData.__typename;

          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: formkey,
              data: {
                Memo_Number: MemoUpdationData?.ConnectionMemoUpdateId_Data,
                Received_At: MemoUpdationData?.Received_At_Data,
                Branch_Code: MemoUpdationData?.Branch_Code_Data,
              },
            },
          });

          MemoUpdationData.Memo_Number = MemoUpdationData?.ConnectionMemoUpdateId_Data?.Connection_No;
          MemoUpdationData.Received_At = MemoUpdationData?.Received_At_Data?.Warehouse_Name;
          MemoUpdationData.Date = IsoToDateWithoutTime(MemoUpdationData?.Date);
          updateValueForm(formRef, MemoUpdationData);
        });
      } else {
        if (openByCard) {
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: formkey,
              data: {
                Received_At: {
                  _id: FormDetailsByCard?.Connection_Memo_Data?.To_Connection_Center_Data?._id,
                  Search_Value: FormDetailsByCard?.Connection_Memo_Data?.To_Connection_Center_Data?.Warehouse_Name,
                },
                Memo_Number: {
                  _id: FormDetailsByCard?.Connection_Updation_Data?._id,
                  Search_Value: FormDetailsByCard?.Connection_Updation_Data?.Connection_No,
                  Reffer_To: FormDetailsByCard?.Connection_Memo_Data?.To_Connection_Center_Data?._id,
                },
                Branch_Code: FormDetailsByCard?.Connection_Memo_Data?.To_Connection_Center_Data?.Warehouse_Branch_Data,
              },
            },
          });
          updateSingleField(
            formRef,
            "Received_At",
            FormDetailsByCard?.Connection_Memo_Data?.To_Connection_Center_Data?.Warehouse_Name
          );
          updateSingleField(formRef, "Branch_Code", FormDetailsByCard?.Connection_Memo_Data?.To_Connection_Center_Data?.Warehouse_Branch_Data?.Name);
          updateSingleField(formRef, "Memo_Number", FormDetailsByCard?.Connection_Updation_Data?.Connection_No);
        }
        updateSingleField(formRef, "Date", GetTodaysDateINdmy());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fielddata, InputFields]);

  const submit = async (close) => {
    let data = {
      Date: convertToISO(FormData?.Date),
      ConnectionMemoUpdateId: memoId,
      ConnectionMemoReceiveData: connectionUpdationData,
      LoadReceiptsIds: loadIds,
      Received_At: FormDataFromRedux?.MasterData[formkey]?.Received_At?._id,
    };
    if (TypeOfPortal === "Edit") {
      await EditConnectionMemoReceive({
        variables: { id: fielddata?._id, newConnectionMemoReceiveInput: data },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Destination Inward Edited Successfully");
          Closeformfunction1();
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else {
      await CreateConnectionMemoReceive({
        variables: {
          ConnectionMemoReceiveInput: data,
        },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Destination Inward Created Successfully");
          if (close === "close") {
            Closeformfunction1();
          } else {
            ClearSpecificForm(dispatch, formkey);
            setTableFields({});
            handleFormReset(formRef);

            updateValueForm(formRef, {
              Date: GetTodaysDateINdmy(),
            });
          }
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
  };

  useEffect(() => {
    if (TypeOfPortal === "Add" && FormDataFromRedux?.MasterData?.Connection_Memo_Receive?.Memo_Number) {
      GetLRData({
        variables: {
          id: FormDataFromRedux?.MasterData?.Connection_Memo_Receive?.Memo_Number._id,
        },
      })
        .then((res) => {
          // console.log(res);
          let UpdationData = res?.data?.getConnectionMemoUpdate_WithConnectionMemoIdAndConnectionNumber;
          setMemoId(UpdationData?._id);
          setLoadIds(UpdationData?.LoadReceiptsIds);
          let obj = {};
          // setMemoId(res.data.getConnectionMemoByIdWithLR[0]._id);
          let temp = UpdationData.ConnectionMemoUpdationData;
          temp.forEach((item) => {
            const key = Math.random() * 10;
            obj[key] = formFieldupdation.map((fieldConfig) => {
              // console.log(fieldConfig);
              if (
                fieldConfig.name === "LR Number" ||
                fieldConfig.name === "No Of Boxes" ||
                fieldConfig.name === "Received"
              ) {
                return {
                  ...fieldConfig,
                  value:
                    item[
                    fieldConfig.name === "LR Number"
                      ? "LR_No"
                      : fieldConfig.name === "No Of Boxes"
                        ? "Connected"
                        : fieldConfig.name === "Received"
                          ? "Connected"
                          : ""
                    ],
                };
              } else {
                return {
                  ...fieldConfig,
                };
              }
            });
          });
          console.log(obj);
          setTableFields(obj);
          let arr1: any = [];
          for (let i = 0; i < temp.length; i++) {
            let obj1: any = {};
            obj1.LoadReceiptId = temp[i].LoadReceiptId;
            obj1.Total_Number_Of_Boxes = temp[i].Connected;
            obj1.Short = 0;
            obj1.Received = temp[i].Connected;
            arr1.push(obj1);
          }
          setConnectionUpdationData(arr1);
        })
        .catch((err) => console.log(err));
    }
  }, [FormDataFromRedux?.MasterData?.Connection_Memo_Receive?.Memo_Number]);


  const handleTableChange = ({ name, value }: any, index: any, key: any) => {
    let totalBoxes = 0;
    let newValue = 0;
    setTableFields((prev) => {
      if (prev[key]) {
        return {
          ...prev,
          [key]: prev[key].map((field) => {
            if (field.name === "No Of Boxes") {
              totalBoxes = field.value;
            }
            if (field.name === "Short") {
              if (value > totalBoxes) {
                return { ...field, value: 0 };
              } else {
                return { ...field, value: totalBoxes - value };
              }
            }
            if (field.name === name) {
              if (value > totalBoxes) {
                WarningToast("Received should be less then No of boxes");
                newValue = totalBoxes;
                // return { ...field, value: totalBoxes };
                var obj = { ...field, value: "" };
                clearTimeout(previousValue.current);
                previousValue.current = setTimeout(() => {
                  setTableFields((prevState) => {
                    return {
                      ...prevState,
                      [key]: prevState[key].map((f) => {
                        if (f.name === name) {
                          return { ...f, value: totalBoxes };
                        }
                        return f;
                      }),
                    };
                  });
                }, 100);

                return obj;
              } else {
                newValue = Number(value);
                return { ...field, value };
              }
            }

            return field;
          }),
        };
      }
      return prev;
    });
    setConnectionUpdationData((prev: any) => {
      return prev.map((item: any, idx: any) => {
        if (idx === index) {
          return {
            ...item,
            Short: item.Total_Number_Of_Boxes - value,
            [name]: value,
          };
        }
        return item;
      });
    });
  };

  let handleDeleteUpdation = async () => {
    await DeleteConnectionMemoReceive({
      variables: {
        idsToDelete: selectedRows,
      },
    })
      .then((res) => {
        dispatch({ type: "Refetch", payload: true });
        SuccessToast("Connection Receive Deleted Successfully");
        Closeformfunction1();
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  }

  if (TypeOfPortal === "Delete") {
    return (
      <Reactportal open={openModal} onClose={() => setOpenModal(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={handleDeleteUpdation}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            setOpenModal(false);
          }}
          loadingState={DeleteLoading}
        />
      </Reactportal>
    );
  }

  return (
    <>
      {openModal ? (
        <div>
          <Reactportal
            open={openModal}
            onClose={Closeformfunction1}
            TypeOfPortal={TypeOfPortal + " " + " Destination Inward"}
            Form_Key={formkey}
            ShowBranchInput={true}
          >
            <div className="MemoReceive">
              {getLoading ? (
                <div className="loader-line-div" />
              ) : (
                <div className="horizontalcontainer">
                  {InputFields &&
                    InputFields.map((e) => {
                      return (
                        <div key={e.id} className="">
                          <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                          <div className="horizantalSection insidecontainer">
                            <FormInputSectionComponent
                              inputfields={e.fields}
                              Type={e.name}
                              onhandleFormikChange={HanldeChangeonForm}
                              validation_Schema={e?.Valid_schema}
                              onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                              formkey={formkey}
                              formRef={formRef}
                              setFirstLoad={setFirstLoad}
                            />
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}

              <div className="inputTable">
                <InputsInTable
                  title={"Connection Memo Receive"}
                  headers={headers}
                  checkDisable={arr}
                  data={tableFields}
                  HandleInputChange={(val: any, a, key, i) => handleTableChange(val.target, i, key)}
                  handleOnFocus={() => { }}
                  handleDelete={(key: any) => {
                    // setTableFields((prev) => {
                    //   const { [key]: _, ...rest } = prev;
                    //   return rest;
                    // });
                  }}
                />
              </div>
              {/* <div className="addConnectionBtn">
                <Button
                  name="modalbutton"
                  text="Add Connection"
                  action={handleAddClick}
                  type={""}
                  children={""}
                  disabled={""}
                ></Button>
              </div> */}
            </div>

            <PortalFooter
              renderContent={() => <></>}
              disabled={false}
              submitform={submit}
              submitType={submitType}
              SaveAndClose={() => {
                submit("close");
              }}
              handleformclose={() => {
                Closeformfunction1();
              }}
              loadingState={loader}
            />
          </Reactportal>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default AddConnectionMemoReceive;
